import _ from 'underscore';
import View from '../view';

var Alert,
  defaults = {
    closeable: true,
    removeAfterClosing: true,
    type: 'notice',
  };

Alert = View.extend({
  template: 'components/alert',

  events: {
    'click .close.icon': 'close',
  },

  initialize: function (options) {
    var self = this;

    this.opts = _.extend({}, defaults, options);
    this._parse();

    this.$el.find('.close.icon').on('click', function () {
      self.close();
    });
  },

  /**
   * Insert alert element in the set of matched elements to the end of the target.
   */
  appendTo: function (container) {
    this.$el.appendTo($(container));

    return this;
  },

  /**
   * Fade-out the alert through the page.
   *
   * If options.removeAfterClosing is true, it will remove the element from DOM after hiding it.
   */
  close: function (e) {
    var self = this;

    if (e) {
      e.preventDefault();
    }

    this.$el.fadeOut(function () {
      if (self.opts.removeAfterClosing) {
        if (self.el.parentNode) {
          self.trigger('closed');
          self.$el.remove();
        }
        self.off();
        self.stopListening();
      }
    });
  },

  /**
   * Insert alert element in the set of matched elements to the beginning of the target.
   */
  prependTo: function (container) {
    this.$el.prependTo($(container));

    return this;
  },

  /**
   * Fade-in the alert through the page
   */
  show: function () {
    if (!this.$el.length) {
      return;
    }

    this.$el.show();
    return this;
  },

  /**
   * Private helper functions below
   */
  _parse: function () {
    var parsedTemplate;

    if (this.opts.dom) {
      this.$el = this.opts.dom;
    } else {
      parsedTemplate = this._parseTemplate();
      this.$el = $(parsedTemplate);
    }
    this.el = this.$el[0];

    return this;
  },

  _parseTemplate: function () {
    return JST['templates/' + this.template]({
      message: this.opts.message,
      type: this.opts.type,
      closeable: this.opts.closeable,
    });
  },
});

module.exports = Alert;
